<template lang="pug">
include /mixins
card(variant='tour')
  card-panel(offset='vertical')
    validation-observer(
      ref='observer',
      v-slot='{ invalid }',
      tag='form',
      @submit.prevent='submit'
    )
      first-step(
        :order='order',
        :data-info='componentData',
        :total-price='totalPrice',
        @cash-selected='$emit("cash-selected", $event)',
        @shipment='$emit("shipment", $event)',
        @payment='$emit("payment", $event)',
        @set-info='updateInfo'
        :currency='currency'
        ref='firstStep'
      )
      second-step(
        :order='order',
        ref='secondStep',
        :data-info='componentData',
        :total-price='totalPrice',
        @cash-selected='$emit("cash-selected", $event)',
        @shipment='$emit("shipment", $event)',
        @payment='$emit("payment", $event)',
        @set-info='updateInfo'
        :currency='currency'
      )
</template>

<script>

import FirstStep from './checkoutSteps/FirstStep'
import SecondStep from './checkoutSteps/SecondStep'

export default {
  components: {
    FirstStep,
    SecondStep
  },
  props: {
    order: {
      required: true
    },
    totalPrice: {
      required: true
    },
    currency: {
      required: false,
      default: 'USD'
    },
  },
  data() {
    return {
      activeStep: 0,
      steps: [
        { id: 0, component: FirstStep },
        { id: 2, component: SecondStep }
      ],
      componentData: {}
    }
  },
  computed: {
    currentComponent() {
      return this.steps[this.activeStep]
    }
  },
  methods: {
    async submit() {
      const valid = (await this.$refs.observer.validate())
      console.log(valid);
      if (valid) {
        try {
          console.log('fist');
          await this.$refs.firstStep.submit()
          console.log('second');
          setTimeout(async () => {
            await this.$refs.secondStep.submitFn()
          }, 1000);
        } catch (err) {
          console.error(err)
        }

      }
    },
    updateInfo(event) {
      console.log(event, '>EVENT')
      Object.keys(event).forEach(key => {
        this.$set(this.componentData, key, event[key])
      })
      this.goForward()
    },
    goForward() {
      this.activeStep++
    }
  }
}
</script>
